import React from 'react'
import TextField, { TextFieldProps } from '@mui/material/TextField'
import { OutlinedInputProps } from '@mui/material/OutlinedInput'
import { styled } from '@mui/material/styles'

type ICustomInputProps = {
  withAdornment?: boolean
  backgroundColor?: string
  isDatePicker?: boolean
} & TextFieldProps

export const CustomInput = styled(
  ({
    isDatePicker,
    withAdornment,
    backgroundColor,
    ...props
  }: ICustomInputProps) => {
    return (
      <TextField
        InputProps={{ disableUnderline: true } as Partial<OutlinedInputProps>}
        {...props}
      />
    )
  },
)(({ theme, backgroundColor }) => ({
  '& label': {
    marginLeft: 4,
    fontFamily: 'inherit',
    fontWeight: 700,
    fontSize: '14px',
    color: '#6b5a5e',
  },
  '& label.MuiInputLabel-shrink': {
    fontSize: '14px',
  },
  '& label.Mui-focused': {
    color: 'var(--color-primary)',
  },
  '& label.Mui-error': {
    color: 'var(--color-primary)',
  },
  // 16px keeps iOS Safari from zooming into the field on focus
  '& .MuiFilledInput-input': {
    fontFamily: 'inherit',
    fontSize: '16px',
    fontWeight: 700,
    color: '#24171a',
    backgroundColor: 'transparent',
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  '& .MuiFilledInput-root': {
    overflow: 'hidden',
    borderRadius: 16,
    backgroundColor: backgroundColor || '#fbf4ee',
    transition: theme.transitions.create(['background-color', 'box-shadow']),
    boxShadow: 'inset 0 0 0 1.5px rgba(36, 23, 26, 0.08)',

    '&::before, &::after': {
      display: 'none',
    },
    '&:hover': {
      backgroundColor: '#f7ede5',
    },
    '&.Mui-focused': {
      backgroundColor: '#fff',
      boxShadow:
        'inset 0 0 0 2px var(--color-primary), 0 0 0 4px rgba(var(--color-primary-rgb), 0.12)',
    },
    '&.Mui-error': {
      boxShadow: 'inset 0 0 0 2px var(--color-primary)',
      animation: 'shake 0.4s ease',
    },
  },
}))
